// extracted by mini-css-extract-plugin
module.exports = {"varFontSize200":"var(--tkww-union-typography-scale-200-font-size, 0.875rem)","addToWebsiteLink":"addToWebsiteLink--92137"};